exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-toolbar>.btn-group[data-v-dad5918e]{margin-top:.3rem;margin-bottom:.5rem;width:100%}.button-toolbar>.btn-group>.btn[data-v-dad5918e]{min-width:20%}", ""]);

// exports
